'use client';

import './donate-form.scss';

import React from 'react';

import { Form } from '@sola/ark-core/molecules/form/form.tsx';

import { DonateAmountSelector } from './components/donate-amount-selector.tsx';
import { DonateFrequencySelector } from './components/donate-frequency-selector.tsx';
import { DonateImpactText } from './components/donate-impact-text.tsx';
import { DonateSubmitButton } from './components/donate-submit-button.tsx';
import { useDonate } from './donate-context.tsx';
import { DonateFrequency } from './donate.types.ts';
import { useDonateActions } from './hooks/use-donate-actions.tsx';

export interface DonateFormProps {
  focusOnLoad?: boolean;
  alt?: boolean;
}
export const DonateForm: React.FC<DonateFormProps> = ({
  focusOnLoad = false,
  alt,
}) => {
  const { variant, state } = useDonate();
  const { handleSubmit } = useDonateActions();

  return (
    <Form
      onSubmit={handleSubmit}
      options={{
        defaultValues: {
          donateFrequency: state.donateFrequency,
          [`${DonateFrequency.OneTime}-donateAmount`]:
            state.selectedAmounts[DonateFrequency.OneTime],
          [`${DonateFrequency.Monthly}-donateAmount`]:
            state.selectedAmounts[DonateFrequency.Monthly],
          [`${DonateFrequency.Annually}-donateAmount`]:
            state.selectedAmounts[DonateFrequency.Annually],
        },
      }}
    >
      <div
        className={`Donate Donate--${variant} flex flex-col ${
          variant === 'grid' ? 'gap-comfy-md' : 'gap-comfy-lg'
        }`}
      >
        {alt && (
          <>
            <div className="flex flex-row gap-comfy-sm">
              <DonateFrequencySelector alt={alt} />
              <DonateAmountSelector alt={alt} focusOnLoad={focusOnLoad} />
            </div>
            <DonateSubmitButton alt={alt} />
          </>
        )}
        {!alt && (
          <>
            <DonateFrequencySelector />
            <DonateAmountSelector focusOnLoad={focusOnLoad} />
            <DonateImpactText />
            <DonateSubmitButton />
          </>
        )}
      </div>
    </Form>
  );
};
